import Box from "@mui/joy/Box";
import { formLabelClasses } from "@mui/joy/FormLabel";
import { Link as RouterLink } from "react-router-dom";
import RoutesConst from "@consts/RoutesConst";
import logoWhite from "@images/logos/logoWhite.png";
import GeneralStrings from "@strings/GeneralStrings.json";
import { getCurrentYear } from "@utilities/DateHelper";

const LoginLayout = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={() => ({
      width:
        "clamp(100vw - var(--Cover-width), (var(--Collapsed-breakpoint) - 100vw) * 999, 100vw)",
      transition: "width var(--Transition-duration)",
      transitionDelay: "calc(var(--Transition-duration) + 0.1s)",
      position: "relative",
      zIndex: 1,
      display: "flex",
      justifyContent: "flex-end",
      backdropFilter: "blur(12px)",
    })}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        width:
          "clamp(var(--Form-maxWidth), (var(--Collapsed-breakpoint) - 100vw) * 999, 100%)",
        maxWidth: "100%",
        px: 2,
      }}
    >
      <Box
        component="header"
        sx={{
          py: 3,
          display: "flex",
          alignItems: "left",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ gap: 2, display: "flex", alignItems: "center" }}>
          <RouterLink to={RoutesConst.DEFAULT} className="logo-link">
            <img
              src={logoWhite}
              className="logo"
              alt={GeneralStrings.beatsByZer0}
            />
            <span>{GeneralStrings.beatsByZer0}</span>
          </RouterLink>
        </Box>
      </Box>

      <Box
        component="main"
        sx={{
          my: "auto",
          py: 2,
          pb: 5,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: 400,
          maxWidth: "100%",
          mx: "auto",
          borderRadius: "sm",
          "& form": {
            display: "flex",
            flexDirection: "column",
            gap: 2,
          },
          [`& .${formLabelClasses.asterisk}`]: {
            visibility: "hidden",
          },
        }}
      >
        {children}
      </Box>

      <Box component="footer" sx={{ py: 3 }}>
        <div className="text-center fs-12">
          <span> © {getCurrentYear()} </span>
          <span
            dangerouslySetInnerHTML={{ __html: GeneralStrings.footerHtml }}
          />
        </div>
      </Box>
    </Box>
  </Box>
);

export default LoginLayout;
